import type { Tenant } from '@/payload-types';

export const fetchTenant = async (tenantId: string): Promise<Tenant> => {
  const res = await fetch(`/api/tenants/${tenantId}`);
  return res.json();
};
